export default "__VITE_ASSET__KCUAJzEI__"